// Closed enum of pedigree sidebar panel ids.
//
// Extracted into this dependency-free leaf module (no React/d3/MUI imports) so
// that both the React components AND the Node vocabulary generator
// (scripts/va-vocab/generate.js) can import it. The host `util.js` imports d3
// and ~20 MUI icon modules, which crash a plain Node import — hence this split.
// `util.js` re-exports SIDEBAR_VALUE from here so existing importers are
// unaffected.
export const SIDEBAR_VALUE = {
  legend: 'legend',
  person: 'person',
  familyHistory: 'familyHistory',
  addRelative: 'addRelative',
  labels: 'labels',
  // epic integration
  emr: 'emr',
  tags: 'tags',
  externalFamilyIds: 'externalFamilyIds',
  externalPatientIds: 'externalPatientIds',
  riskFactors: 'riskFactors',
  phenotypes: 'phenotypes',
  genotypes: 'genotypes',
  diagnoses: 'diagnoses',
  clinicalNotes: 'clinicalNotes',
  suggestions: 'suggestions',
  pedigreeMatch: 'pedigreeMatch',
  export: 'export',
  setupPatientAccess: 'setupPatientAccess',
  formSubmission: 'formSubmission',
  pathways: 'pathways',
  pedigreeConfig: 'pedigreeConfig',
  familyNote: 'familyNote',
  recordStatus: 'recordStatus',
  reproductive: 'reproductive'
};
